import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { ModulesInlineEditor } from '@/resources/modules';
import type { Course } from '../types';

interface CourseModulesTabProps {
  course: Course;
  onRefresh: () => void;
}

export function CourseModulesTab({ course, onRefresh }: CourseModulesTabProps) {
  const [addModuleOpen, setAddModuleOpen] = useState(false);

  return (
    <div className="space-y-4 pt-6">
      <div className="flex items-center justify-end">
        <Button className="shrink-0" onClick={() => setAddModuleOpen(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Добавить модуль
        </Button>
      </div>

      <ModulesInlineEditor
        courseId={course.id}
        modules={course.modules ?? []}
        onRefresh={onRefresh}
        addModuleOpen={addModuleOpen}
        onAddModuleOpenChange={setAddModuleOpen}
      />
    </div>
  );
}
